import { cn } from '@/lib/utils';

/**
 * Skeleton com shimmer — gradiente deslizante premium
 * em vez do animate-pulse padrão.
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'rounded-lg overflow-hidden',
        'animate-shimmer bg-gradient-to-r from-muted via-muted/40 to-muted bg-[length:200%_100%]',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
